<template>
  <v-ons-page>
    <v-ons-splitter>
      <v-ons-splitter-side
        swipeable
        collapse
        width="250px"
        side="left"
        :open.sync="menuIsOpen">
        <main-menu
          @push-page="pushPage">
        </main-menu>
      </v-ons-splitter-side>

      <v-ons-splitter-content>
        <navigator
          :pageStack="pageStack"
          @push-page="pushPage"
          @pop-page="$emit('pop-page')"
          @toggleMainMenu="toggleMainMenu"
          @refreshContent="$emit('refreshContent')">
        </navigator>
      </v-ons-splitter-content>
    </v-ons-splitter>
  </v-ons-page>
</template>

<script>
import Navigator from '../components/Navigator'
import MainMenu from '../components/MainMenu'

export default {
  name: 'parent',
  props: {
    pageStack: Array
  },
  data () {
    return {
      menuIsOpen: false,
    }
  },
  methods: {
    toggleMainMenu() {
      this.menuIsOpen = !this.menuIsOpen
    },
    pushPage(page) {
      this.$emit('push-page', page);
      this.menuIsOpen = false;
    },
  },
  components: {
    Navigator,
    MainMenu
  },
  created() {

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/Option1/Parent.vue